import * as React from 'react';
import { MessageWithActionAndData } from "@me8eon/sessions_messages";
import { useMemo } from "react";
import { Feedback } from "../../../../features/Feedback/organisms/Feedback";
import styles from "./MessageList.module.scss";
import { useMapMessagesToComponentsHook } from "../../hooks/useMapMessagesToComponents.hook";
import { AiLoader } from '@me8eon/ai_loader';

export interface MessageListProps {
    messages: MessageWithActionAndData[];
    pending: boolean;
    showLoader: boolean;
    isStreaming: boolean;
}

export function MessageList({
    messages,
    pending,
    showLoader,
    isStreaming,
}: MessageListProps) {

    const messagesToDisplay = useMemo(
        () => useMapMessagesToComponentsHook(messages),
        [messages]
    );

    const showFeedback = useMemo(
        () => {
            const lastStableAssistant = [...messages]
                .reverse()
                .find(m => m.role === "assistant" && !(m.data as any)?.streaming);

            return !pending && Boolean(lastStableAssistant);
        },
        [messages, pending]
    );

    return (
        <div className={styles.messageList}>
            {messagesToDisplay.map(m => m)}
            {showLoader && (<AiLoader />)}
            {(showLoader || isStreaming) && (
                <div style={{ visibility: "hidden", minHeight: "400px" }} />
            )}
            <div style={{ marginLeft: "60px" }}>
                {showFeedback && <Feedback />}
            </div>
        </div>
    );
}
